// test2392
(2392 && 0);
